const isRTX = (organizationName?: string) => (
  organizationName?.toLowerCase() === "rtx"
);

export default isRTX;
